import { useRef, useState } from 'react';
import { cn, PaletteUtils } from '@shared/utils';

interface OTPInputProps {
  className?: string;
  error?: boolean;
  length?: number;
  value?: string;
  onChange?: (pin: string) => void;
}

export const OTPInput = (props: OTPInputProps) => {
  const { length = 6 } = props;

  const [OTP, setOTP] = useState<string[]>(() => (props.value ? props.value.split('').slice(0, length) : Array(length).fill('')));
  const inputRef = useRef<HTMLInputElement[]>(Array(length).fill(null));

  const changeHandler = (input: string, idx: number) => {
    const newPin = [...OTP];
    newPin[idx] = input;
    setOTP(newPin);
    props.onChange?.(newPin.join(''));

    if (input && idx < length - 1) inputRef.current[idx + 1]?.focus();
    if (!input && idx > 0) inputRef.current[idx - 1]?.focus();
  };

  return (
    <div className={cn('flex gap-[10px]', props.className)}>
      {Array.from({ length }, (_, idx) => (
        <input
          key={idx}
          ref={(ref) => (inputRef.current[idx] = ref as HTMLInputElement)}
          className={cn(
            'h-10 w-10 rounded border border-solid p-1 text-center outline-none transition-colors duration-200 dark:bg-slate',
            PaletteUtils.isInsigniaPalette && ['border-slate-500', 'hover:border-primary', 'focus:border-primary'],
            PaletteUtils.isVcfcPalette && ['border-light', 'hover:border-primary-darkest', 'focus:border-primary-darkest'],
            props.error && 'border-red',
          )}
          type='text'
          inputMode='numeric'
          maxLength={1}
          value={OTP[idx] ?? ''}
          onChange={(e) => changeHandler(e.target.value, idx)}
        />
      ))}
    </div>
  );
};
